module.exports = __webpack_public_path__ + "static/core-e4f5010a7b0fb7e83f53b3c3a523142e.png";